import { Amplify, ResourcesConfig } from 'aws-amplify';

import { EnvironmentType } from '../../../environment/types/environment.types.ts';

import { getAwsAuthUtil } from './aws-auth.util.ts';

export class AwsConfigUtil {
  private static _instance: AwsConfigUtil;

  static get instance(): AwsConfigUtil {
    if (!AwsConfigUtil._instance) {
      AwsConfigUtil._instance = new AwsConfigUtil();
    }

    return AwsConfigUtil._instance;
  }

  configureAws(props: EnvironmentType): void {
    const { apiUrl, apiKey, userPoolRegion, userPoolId, userPoolClientId } = props;

    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId,
          userPoolClientId,
        },
      },
      API: {
        GraphQL: {
          region: userPoolRegion,
          endpoint: apiUrl,
          apiKey,
          defaultAuthMode: 'userPool',
        },
      },
    });

    getAwsAuthUtil().initialize();
  }

  get config(): ResourcesConfig {
    return Amplify.getConfig();
  }
}

export const getAwsConfigUtil = (): AwsConfigUtil => AwsConfigUtil.instance;
